__turbopack_context__.v({
  "bar": "g1DIDa_bar",
  "bar-fade-in": "g1DIDa_bar-fade-in",
  "bar-sweep": "g1DIDa_bar-sweep",
  "srOnly": "g1DIDa_srOnly",
});
